import React from 'react';
import Layout from './layouts/layout';

function App() {
  return <Layout />;
}

export default App;
